import type { FormField } from 'App/resources/Model/Form';
import type { fieldValue } from 'App/resources/Model/FormSubmit';

/** Form-field names already rendered as native guest-list columns — never offered in the picker. */
export const NATIVE_FIELD_NAMES = ['Contact.firstname', 'Contact.lastname', 'Contact.email'];

/** localStorage key holding the selected field names — per browser, global across events. */
export const SELECTED_COLUMNS_STORAGE_KEY = 'socialEventGuestListColumns';

export const getPickableFields = (formFields: FormField[]): FormField[] =>
	(formFields || []).filter(field => !NATIVE_FIELD_NAMES.includes(field.name));

export const getSelectedColumnNames = (): string[] => {
	try {
		const raw = window.localStorage.getItem(SELECTED_COLUMNS_STORAGE_KEY);
		const parsed = raw ? JSON.parse(raw) : [];
		return Array.isArray(parsed) ? parsed : [];
	} catch (e) {
		// Corrupt/unavailable storage → fall back to no custom columns.
		return [];
	}
};

export const setSelectedColumnNames = (names: string[]): void => {
	window.localStorage.setItem(SELECTED_COLUMNS_STORAGE_KEY, JSON.stringify(names));
};

type SubmitLike = { contact: { id: number } | null; fieldValues?: fieldValue[] };

/**
 * Build a { [contactId]: { [fieldName]: value } } map from form submits.
 * The caller must pass submits sorted latest-first; the first submit seen per contact wins.
 */
export const buildContactFieldValueMap = (submits: SubmitLike[]): Record<number, Record<string, string>> => {
	const map: Record<number, Record<string, string>> = {};
	(submits || []).forEach(submit => {
		const contactId = submit.contact?.id;
		if (!contactId || map[contactId]) {
			return;
		}
		const values: Record<string, string> = {};
		(submit.fieldValues || []).forEach(fv => {
			values[fv.name] = fv.value;
		});
		map[contactId] = values;
	});
	return map;
};
